import { shape, string, arrayOf, number } from 'prop-types';
import React from 'react';

import { formatAmount, getDeliveryFormatted } from '../../../utils'

import s from './index.module.css';

const OrderMessage = ({ order }) => {
  const { deliveryDays, amount, items, sellerAddress = '' } = order;
  const deliveryDate = getDeliveryFormatted(deliveryDays);
  const deliveryText = deliveryDays > 0
    ? `Доставка на ${deliveryDays} день · ${deliveryDate}`
    : 'В пункте самовывоза сегодня';
  const isOneItem = items.length === 1;

  const getDetailTitle = (makeName, detailName) => {
    if (!makeName && !detailName) {
      return '';
    }

    if (!makeName && detailName) {
      return detailName;
    }

    return `${makeName} · ${detailName}`;
  };

  return (
    <div className={s.wrapper}>
      <div className={s.headerWrapper}>
        {sellerAddress && (
          <h3 className={s.sellerAddress}>
            Заказ из пункта выдачи {sellerAddress}
          </h3>
        )}
        <div className={s.delivery}>{deliveryText}</div>
      </div>
      <div className={s.itemsWrapper}>
        {
          items.map((item, index) => (
            <React.Fragment key={index}>
              <div className={s.itemPosition}>{!isOneItem && `${index + 1}.`}</div>
              <div className={s.itemName}>{getDetailTitle(item.makeName, item.detailName)}</div>
              <div className={s.itemQuantity}>{item.quantity} шт.</div>
              <div className={s.itemAmount}>{formatAmount(item.amount)} ₽</div>
            </React.Fragment>
          ))
        }
      </div>

      {!isOneItem && (
        <div className={s.footer}>
          <div className={s.amount}>
            <span className={s.amountText}>Итого&nbsp;&nbsp;</span>
            <span className={s.value}>{formatAmount(amount)} ₽</span>
          </div>
        </div>
      )}
    </div>
  );
};

OrderMessage.propTypes = {
  order: shape({
    amount: number,
    delivery: string,
    items: arrayOf(shape({
      detailName: string,
      amount: number,
      price: number,
      quantity: number,
    }))
  }),
};

OrderMessage.defaultProps = {
  order: {
    items: [],
  }
};

export default OrderMessage;
